import { Typography } from "@mui/material";
import React, { useContext } from "react";
// import { Link } from "react-router-dom";
import { useUserProvider } from "../context/UserProvider";
import "../App.css";
import {
  Paper,
  Card,
  CardContent,
  Button,
  TextField,
  CssBaseline,
  Container,
  Stack,
  FormControl,
  Link,
  Grid,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";

import { ColorModeContext } from "../context/ColorModeProvider";

import LogoCirclesLight from "../images/logo_circles_light.svg";
import LogoCirclesDark from "../images/logo_circles_dark.svg";
import LogoA from "../images/logo_a.svg";
import LogoALight from "../images/logo_a_light.svg";

import Sponsor1 from "../images/sponsor_1.png";
import Sponsor2 from "../images/sponsor_2.png";
import Sponsor1Light from "../images/sponsor_1_light.png";
import Sponsor2Light from "../images/sponsor_2_light.png";

import startIllu from "../images/acoustic_illu.svg";

import SignInForm from "./SignInForm";

// import { Button } from "react-bootstrap";

export default function StartPage({ role, createdAt, id }) {
  const { theme } = useContext(ColorModeContext);
  // const { user } = useUserProvider();
  const { user, user: currentUser } = useUserProvider();
  // const belongsToCurrentUser = (currentUser, siteAuthor) => {
  //   if (!currentUser) return false;

  //   return currentUser.uid === siteAuthor.uid;
  // };
  //   const { uid, displayName, email, photoURL } = auth.currentUser || {};
  return (
    <>
      <CssBaseline />
      {/* <div
        className="main-section"
        style={{ height: "100vh", display: "flex" }}
      > */}
      <Grid
        className={theme.palette.mode === "dark" ? "start_dark" : "start_light"}
        sx={{
          // background: "linear-gradient(45deg, #037FFF 15%, #50E3C2 90%)",
          minWidth: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          position: "absolute",
          top: "0",
          left: "0",
        }}
        spacing={0}
        alignItems="center"
        justify="center"
      >
        <header className="App-header">
          <Grid
            container
            spacing={0}
            justifyContent="center"
            sx={{
              marginTop: {
                xs: "-100px",
                sm: "-60px",
                md: "-60px",
                lg: "-60px",
              },
            }}
          >
            <Grid
              item
              mt={4}
              sx={{
                marginBottom: {
                  xs: ".8em",
                  sm: "2em",
                  md: "2em",
                  lg: "2em",
                },
              }}
            >
              <div className="combined_logo">
                {theme.palette.mode === "dark" ? (
                  <img
                    src={LogoCirclesDark}
                    className="App-logo_circles"
                    alt="logo"
                    //   width="400px"
                  />
                ) : (
                  <img
                    src={LogoCirclesLight}
                    className="App-logo_circles"
                    alt="logo"
                    //   width="400px"
                  />
                )}
                {theme.palette.mode === "dark" ? (
                  <img
                    //   width="400px"
                    src={LogoA}
                    className="App-logo_a"
                    alt="logo"
                  />
                ) : (
                  <img
                    //   width="400px"
                    src={LogoALight}
                    className="App-logo_a"
                    alt="logo"
                  />
                )}
              </div>
            </Grid>
          </Grid>
        </header>
        {user ? (
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={6} md={2.5}>
              {/* <img src={illu} width="300px" /> */}
              {/* <Typography variant="h4">Coucou</Typography> */}
              <Stack direction="column" spacing={3}>
                <Typography>
                  {/* You are {!user ? "not logged in" : "logged in"} */}
                </Typography>
                <Button
                  size="medium"
                  variant="contained"
                  className="blue_peps"
                  component="a"
                  href="/dashboard"
                  // style={{ background: "rgb(0, 127, 255)" }}
                  //   endIcon={<OpenInNew />}
                >
                  SITE LIST
                </Button>
                <Button
                  size="medium"
                  variant="contained"
                  component="a"
                  className="dark_blue"
                  href="/addnewsite"
                  // style={{
                  //   border: "1px solid rgba(51, 153, 255, 0.5)",
                  //   background: "transparent",
                  //   color: "rgb(51, 153, 255)",
                  // }}

                  //   endIcon={<OpenInNew />}
                >
                  NEW SITE
                </Button>
              </Stack>
            </Grid>
          </Grid>
        ) : (
          <>
            <SignInForm />

            {/* <Typography>n'suis pas connectey</Typography> */}
          </>
        )}
      </Grid>
      <Grid
        container
        spacing={1}
        sx={{
          position: "absolute",
          // bottom: "20px",
          bottom: {
            xs: "5px",
            sm: "20px",
            md: "20px",
            lg: "20px",
          },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid item>
          <a target="_blank" href="https://environnement.brussels/">
            {theme.palette.mode === "dark" ? (
              <img src={Sponsor1} height={"70px"} />
            ) : (
              <img src={Sponsor1Light} height={"70px"} />
            )}
          </a>
        </Grid>
        <Grid item>
          <a target="_blank" href="https://www.construcity.brussels/">
            {theme.palette.mode === "dark" ? (
              <img src={Sponsor2} height={"70px"} />
            ) : (
              <img src={Sponsor2Light} height={"70px"} />
            )}
          </a>
        </Grid>
      </Grid>
      {/* </div> */}

      {/* <img
        src={startIllu}
        alt="illu"
        sx={{ position: "absolute", bottom: 0, left: 0, height: "100vh" }}
      /> */}
    </>
  );
}
